/* tslint:disable:no-parameter-reassignment */
import { DefaultOrderDetailState, RootState } from '@/store/types';
import { Module } from 'vuex';
import { AvailableDeliverySlotDto } from '@eurogast/hub-client-typescript';

/**
 * This store saves all fields needed for an order in the default-webshop
 * See fair-order-details for fair specific-fields.
 */
export default {
  namespaced: true,
  state: {
    deliverySlot: null
  },
  getters: {},
  actions: {},
  mutations: {
    setDeliverySlot(state, {deliverySlot}: { deliverySlot?: AvailableDeliverySlotDto }) {
      state.deliverySlot = deliverySlot;
    },
    resetCheckoutState(state) {
      state.deliverySlot = null;
    }
  }
} as Module<DefaultOrderDetailState, RootState>;
